import { Controller } from "@hotwired/stimulus";

// The fields for somebody from outside the club (name, e-mail) are shown only
// when the "external" option (value 0) is picked in the person select.
export default class extends Controller {
  static targets = ["row"];

  toggle({target}) {
    const external = target.value === "0";
    this.rowTargets.forEach((row) => {
      row.hidden = !external;
    });
  }
}
